<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-banner icon="mdi-chart-bar">Product Sales Report</v-banner>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-menu
          v-model="startMenu"
          close-on-content-click
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startTextField"
              label="From Date"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            :max="max"
            color="green lighten-1"
            header-color="primary"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-menu
          v-model="endMenu"
          close-on-content-click
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endTextField"
              label="To Date"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            :max="max"
            :min="startDate"
            color="green lighten-1"
            header-color="primary"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="4">
        <v-btn
          block
          outlined
          color="blue darken-2"
          :loading="loadingStats"
          @click.stop="getProductSalesReport"
        >
          <v-icon class="mr-2">search</v-icon>Find
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="11" lg="12">
        <v-toolbar dense v-if="stats.length" class="mb-4" flat color="background">
          <v-icon color="primary">monetization_on</v-icon>
          <v-spacer></v-spacer>
          <v-toolbar-title
            class="subtitle-1 font-weight-medium"
          >Total Sales for the period : £ {{getNetTotal}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-expansion-panels v-if="stats.length" focusable flat accordion class="mt-2 mb-4">
          <v-expansion-panel v-for="(item,i) in stats" :key="i">
            <v-expansion-panel-header expand-icon="mdi-menu-down">
              <span>{{item.group_description}}</span>
              <span>£ {{getGroupTotal(item.categories)}}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-expansion-panels focusable flat accordion class="mt-2 mb-4">
                <v-expansion-panel v-for="(cat,i) in item.categories" :key="i">
                  <v-expansion-panel-header expand-icon="mdi-menu-down">
                    <span>{{cat.category_description}}</span>
                    <span>£ {{getCatTotal(cat.products)}}</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ProductStats :product="cat.products" />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <span v-if="noData" class="subtile-2 font-weight-medium">No Data found</span>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import ProductStats from "@/components/product/ProductStats.vue";

export default {
  name: "SalesReport",
  components: { ProductStats },
  data: () => {
    return {
      startDate: moment()
        .subtract(28, "days")
        .toISOString()
        .substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      startMenu: false,
      endMenu: false,
      stats: [],
      noData: false,
      loadingStats: false
    };
  },
  computed: {
    ...mapGetters(["retrieveUser"]),

    max() {
      return new Date().toISOString().substr(0, 10);
    },
    startTextField() {
      return moment(this.startDate).format("dddd, MMMM Do YYYY");
    },
    endTextField() {
      return moment(this.endDate).format("dddd, MMMM Do YYYY");
    },
    getNetTotal() {
      let netTotal = 0;
      this.stats.forEach(element => {
        let grpTotal = this.getGroupTotal(element["categories"]);
        netTotal = parseFloat(netTotal) + parseFloat(grpTotal);
      });
      return parseFloat(netTotal).toFixed(2);
    }
  },
  methods: {
    ...mapActions([
      "fetchProductSales",
      "sendNutritionReportCsv",
      "setSnackbar"
    ]),

    todaysDate() {
      return new Date();
    },

    async getProductSalesReport() {
      this.loadingStats = true;
      this.stats = [];

      const rec = {
        userId: this.retrieveUser.userNum,
        sessionKey: this.retrieveUser.sessionKey,
        startTime: this.startDate,
        endTime: this.endDate
      };

      let response = await this.fetchProductSales(rec);

      if (response.success == true) {
        this.noData = false;
        this.stats = Object.values(response.prodStats);
        if (this.stats.length == 0) {
          this.noData = true;
        }
      }

      this.loadingStats = false;
    },

    getCatTotal(categoryProducts) {
      const total = categoryProducts.reduce(
        (acc, currElem) => acc + parseFloat(currElem["total"]),
        0
      );
      return parseFloat(total).toFixed(2);
    },

    getGroupTotal(categoriesInGroup) {
      let categories = Object.values(categoriesInGroup);
      let groupTotal = 0;
      categories.forEach(element => {
        groupTotal =
          parseFloat(groupTotal) +
          parseFloat(this.getCatTotal(element["products"]));
      });
      return parseFloat(groupTotal).toFixed(2);
    }
  }
};
</script>

<style lang="sass" scoped>
.v-expansion-panel
  border: 1px solid rgb(232, 232, 232)
</style>